import {
    type BannerPrivacyEnum,
    type LandingContentsParentEnum,
} from '@clients/ContentApi';
import { type ReserveType } from '@utils/itinerary';

export interface SearchResultContentParams {
    service: ReserveType;
    destination: string;
    origin: string;
    hotelName?: string;
}

export type ContentPrune<T extends { created_by?: any; updated_by?: any }> =
    Omit<T, 'updated_by' | 'created_by'>;

export interface CommonMessageProperties {
    id: string;
    mode?: 'once' | 'always';
    closeAction?: 'once' | 'always' | 'none' | null;
}

export interface ContentLike {
    privacy?: BannerPrivacyEnum;
}

export function toAbsoluteSrc(src?: string): string {
    if (!src?.trim()) {
        return '';
    }
    return useBaseUrls().content + src;
}

export type CorporationsDataDto = {
    serviceData: {
        name: string | undefined;
        id: string | undefined;
    }[];
    service: LandingContentsParentEnum;
};
